import { useMutation } from '@tanstack/react-query';

import { accountUserDetailKey } from '../../common/queryKeys';
import AppApi from '../../../../../../lib/api/app/AppApi';
import { setRequestForm } from '../../../../../../lib/common';

export const useGeneratePointMutate = ({ options }) => {
  return useMutation(
    [...accountUserDetailKey, 'pointDetail', 'generate', 'point'],
    async (payload) => {
      const result = await AppApi.generatePoint(setRequestForm(payload, true));
      if (result.msg) throw new Error(result.msg);
      return result;
    },
    {
      ...options,
    },
  );
};
